import { ChangeDetectionStrategy, Component, forwardRef, Input, OnInit } from '@angular/core';
import { ControlValueAccessor, FormBuilder, FormGroup, NG_VALUE_ACCESSOR } from '@angular/forms';
import { LocalStorageService } from '@app/guards/storage.service';
import { MatrixService } from '@shared/service';
import { BehaviorSubject, combineLatest } from 'rxjs';
import { map, switchMap, tap } from 'rxjs/operators';

@Component({
    selector: 'gpe-ng-select-matrix',
    templateUrl: './ng-select-matrix.component.html',
    providers: [
        MatrixService,
        {
            provide: NG_VALUE_ACCESSOR,
            multi: true,
            useExisting: forwardRef(() => NgSelectMatrixComponent),
        },
    ],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NgSelectMatrixComponent implements OnInit, ControlValueAccessor {
    public form: FormGroup
    public data$ = new BehaviorSubject<any>([])
    private _stageId$ = new BehaviorSubject<number>(undefined)
    private _exceptType$ = new BehaviorSubject<number>(undefined)

    constructor(
        private _formBuilder: FormBuilder,
        private _matrixService: MatrixService,
        private _localStorageService: LocalStorageService
    ) {
        this.initForm()
        this.loadData()
    }

    @Input('stageId') public set setStageId(stageId: number) {
        this._stageId$.next(stageId)
    }

    @Input('exceptType') public set setDidacticMaterial(value: number) {
        this._exceptType$.next(value)
    }

    ngOnInit(): void {
    }

    private loadData() {
        const publishingId = this._localStorageService.storageUsuario?.country_selected.editoras[0].id
        combineLatest([this._stageId$, this._exceptType$]).pipe(
                tap(() => this.reset()),
                switchMap(([stageId, exceptType]) => this._matrixService.index(publishingId, stageId, exceptType)),
                map(res => res.ret === 1 ? res.data : []),
        ).subscribe(value => {
            this.data$.next(value)
            if (value.length == 1) {
                this.form.patchValue({id: value[0].id})
                this.onChange(this.form.value.id)
            }
        })
    }

    private initForm() {
        this.form = this._formBuilder.group({
            id: undefined
        })
    }

    private reset() {
        this.form.reset()
        this.onChange(undefined)
    }

    public writeValue(value: number) {
        this.form.patchValue({ id: value })
    }

    public registerOnChange(fn: (v: any) => void): void {
        this.onChange = fn
    }

    public registerOnTouched(fn: () => void): void {
        this.onTouched = fn
    }

    public onSelect(value: any) {
        this.onTouched()
        this.onChange(value?.id)
    }

    private onChange = (_: any) => { }
    private onTouched = () => { }
}
